module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('router-link', {
    attrs: {
      "to": "/abs-new"
    }
  }, [_vm._v("Nuovo Abstract")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23f5854f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 602
// module chunks = 2